import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DisconnectPaynetMutation } from "../graphql/mutations";
import type {
  DisconnectPaynetMutationType,
  DisconnectPaynetMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDisconnectPaynetMutation = (
  options?: MutationHookOptions<
    DisconnectPaynetMutationType,
    DisconnectPaynetMutationVariablesType
  >
) => {
  return useMutation<
    DisconnectPaynetMutationType,
    DisconnectPaynetMutationVariablesType
  >(DisconnectPaynetMutation, options);
};
